<template>
  <div class="container-md">
    <div class="row justify-content-center">
      <div class="forgot-form col-auto">
        <div class="pb-2 text-center">
          <h3>{{ $t("forgot.title") }}</h3>
        </div>
        <form class="border bg-light p-3" @submit.prevent="submit">
          <div class="text-center">
            <label class="text-muted">{{ $t("forgot.message") }}</label>
            <p class="text-muted">{{ $t("forgot.messagePre") }}</p>
          </div>

          <div class="p-2">
            <label for="email">
              {{ $t("signUp.email") }}
            </label>
            <input type="email" class="form-control" id="email" v-model="inputEmail" @blur="validateEmail">
            <p class="text-danger p-margin" v-if="isEmailError">{{ $t("error.noInput") }}</p>
          </div>
          
          <div class="p-2">
            <label for="">
              {{ $t("signUp.dateOfBirth") }}
            </label>
            <date-dropdown :default="inputBirth" min="1900" max="2100" @setInputBirth="setInputBirth" />
          </div>
          
          <div class="p-2">
            <label for="phoneNumber">
              {{ $t("signUp.phoneNumber") }}
            </label>
            <input type="tel" class="form-control" id="phoneNumber" v-model="inputPhoneNumber" @blur="validatePhoneNumber">
            <p class="text-danger p-margin" v-if="isPhoneNumberError">{{ $t("error.noInput") }}</p>
          </div>
          
          <div class="d-grid gap-2 p-2 mt-2">
            <button type="submit" class="btn btn-primary" :disabled="isButtonDisabled">
              <div class="text-center" v-if="!isButtonDisabled">
                {{ $t("provisionalEntry.submit") }}
              </div>
              <div class="text-center" v-if="isButtonDisabled && postResult === ''">
                {{ $t("provisionalEntry.loading") }}
              </div>
              <div class="text-center" v-if="isButtonDisabled && postResult === 'success'">
                {{ $t("provisionalEntry.complete") }}
              </div>
            </button>
            
          </div>
        </form>
      </div>
      <div class="text-center p-2">
        <p class="text-success mb-0" v-if="postResult === 'success'">{{ $t("forgot.success", { email: sentEmail }) }}</p>
        <p class="text-success mt-0" v-if="postResult === 'success'">{{ $t("provisionalEntry.postSuccessBr") }}</p>
        <p class="text-danger" v-if="postResult === 'error'">{{ $t("forgot.error") }}</p>
        <router-link to="/">{{ $t("common.login") }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Const from '../const.js'
import parsePhoneNumber from 'libphonenumber-js'
import DateDropdown from './DateDropdown.vue'
import reCaptchaMixin from "../mixins/reCaptchaMixin";

export default {
  mixins: [reCaptchaMixin],
  props: {
    default: { default: ""}
  },
  components: { DateDropdown },
  data() {
    return {
      inputEmail: "",
      inputBirth: "",
      inputPhoneNumber: "",
      formatPhoneNumber: "",
      sentEmail: "",
      postResult: "",
      isEmailError: false,
      isBirthError: false,
      isPhoneNumberError: false,
      isButtonDisabled: false
    }
  },
  methods: {
    async submit() {
      this.isButtonDisabled = true
      this.isEmailError = false
      this.isPhoneNumberError = false
      this.postResult = ""
      this.formatPhoneNumber = this.toHalfSize(this.inputPhoneNumber)

      this.validatePhoneNumber()
      this.validateEmail()

      if (this.isEmailError || this.isPhoneNumberError) {
        this.isButtonDisabled = false
        return
      }

      let recaptchaToken = ""
      try{
        recaptchaToken = await this.getRecaptchaToken()
      }catch(error){
        this.postResult = "error"
        this.isButtonDisabled = false
      }

      try{
        const body = {
          email_address: this.inputEmail,
          birthday: this.inputBirth,
          phone_number: String(this.formatPhoneNumber).replaceAll("-", ""),
          recaptcha_token:recaptchaToken
        }
        await axios.post(Const.BASE_URL + "/password-reset-mail", body)
        this.sentEmail = this.inputEmail
        this.postResult = "success"
      }catch(error){
        this.postResult = "error"
        this.isButtonDisabled = false
      }
    },
    
    setInputBirth(val) {
      this.inputBirth = val
    },

    validateEmail() {
      const regexpEmail = new RegExp(Const.REGEXP_FOR_EMAIL)

      if (!this.inputEmail || !regexpEmail.test(this.inputEmail)) {
        this.isEmailError = true
      } else {
        this.isEmailError = false
      }
    },
    
    validatePhoneNumber() {
      this.formatPhoneNumber = this.toHalfSize(this.inputPhoneNumber)
      const phoneNumber = parsePhoneNumber(this.formatPhoneNumber, "JP")
     
      if (this.inputPhoneNumber && phoneNumber && phoneNumber.isValid()) {
        this.isPhoneNumberError = false
      } else {
        this.isPhoneNumberError = true
      }
    },
    
    // 全角数字 -> 半角数字
    toHalfSize(str) {
      return str.replace(/[０-９]/g, function(s) {
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
     })
    },
  }
}
</script>

<style scoped>
.p-margin {
  margin: 0;
}
.forgot-form {
  padding-top: 128px;
}
</style>
